/**
 *  Filename ....: agencytable.component.ts
 *  Created by ..: ianday
 *  on Date .....: 10/12/23
 **/
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {MatRow, MatTableDataSource} from "@angular/material/table";
import {User} from "../../../../models/user";
import {Agencies} from "../../../../models/agencies";
import {DwUtils} from "../../../../components/utils/dw-utils";

@Component({
    selector: 'app-agencytable',
    templateUrl: './agencytable.component.html',
    styleUrls: ['./agencytable.component.css']
})

export class AgencyTableComponent implements OnInit {


    public _agencyList: any;
    public selectedAgencyId: number;
    public displayedColumns = ['id', 'agencyName'];
    public dataSource: MatTableDataSource<Agencies>;
    public selectedRecord: any;
    public Idx: number | null = -1;
    public filterStr;
    @Output() agencySelectedHandler: EventEmitter<any> = new EventEmitter();
    @Output() agencyCancelHandler: EventEmitter<any> = new EventEmitter();

    @Input() set agencyList(val: any) {
       this._agencyList = val;
    }
    get agencyList() :any {
        return this._agencyList;
    }
    // for scroll to view.
    @ViewChildren('tableRows', {read: ElementRef}) rows!: QueryList<ElementRef<HTMLTableRowElement>>;

    constructor() {

    }

    ngOnInit() {

    }

    doInitialize(agencyId: number): void {

        if (agencyId === undefined) {
            agencyId = 0;
        }

        if (this.agencyList === undefined) {
            return;
        }
        if (this.agencyList.length === 0) {
            return;
        }
        this.selectedRecord = new Agencies();
        this.selectedAgencyId = agencyId;
        this.Idx = -1;
        this.filterStr = '';
        this.dataSource = new MatTableDataSource(this.agencyList);

        if (this.selectedAgencyId > 0) {
            this.selectedRecord = this.agencyList.find(s => s.id === this.selectedAgencyId);
            this.Idx = this.dataSource.connect().value.indexOf(this.selectedRecord);

            setTimeout(() => {
                this.scrollToIndex(this.selectedRecord.id);
                DwUtils.setFocus('tblAgencyContainerId');

                }, 300);

        }
    }
    public applyFilter(filterValue: string) : void {
        this.dataSource.filter = filterValue.trim().toLowerCase();
        this.unSelectRow();
    }
    public unSelectRow(): void {
        this.Idx = -1;
        this.selectedRecord = new Agencies();
    }
    public onRowClicked(row:any): void {
        this.selectedRecord = row;
        this.Idx = this.dataSource.connect().value.indexOf(this.selectedRecord);
        this.selectedRecord = this.dataSource.filteredData[this.Idx];
    }
    public doubleClickRow():void {
        // the selected Record would be set after the first click.
        this.selectAndThrowEvent();
    }
    public tableKeyDown(event: any): void {
        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.agencyList[++this.Idx];

            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.agencyList[--this.Idx];

            }
        }
        else if(event.key === 'Enter') {
            this.selectedRecord = this.dataSource.filteredData[this.Idx];
            this.selectAndThrowEvent();
        }

        else if(event.key === 'Backspace') {
            if(this.filterStr.length > 0) {
                this.filterStr = this.filterStr.slice(0,-1);
                this.applyFilter(this.filterStr);
            }
        }
        else {
            if(event.key === "Shift") {
                return;
            }
            this.filterStr += event.key;
            this.applyFilter(this.filterStr);
        }

    }
    public selectAndThrowEvent(): void {
        this.agencySelectedHandler.emit(this.selectedRecord);
    }
    private scrollToIndex(id: number): void {
        let elem = this.rows.find(row => row.nativeElement.id === id.toString());
        elem?.nativeElement.scrollIntoView({block: 'center', behavior: 'smooth'});

    }
    public submitRecord(): void {
        this.agencySelectedHandler.emit(this.selectedRecord);
    }
    public cancelSubmitRecord(): void {
        this.agencyCancelHandler.emit();
    }
 }


